import { httpsCallable, httpsCallableFromURL } from 'firebase/functions';
import { functions } from '../config/firebase';

/** Must stay below Cloud Function timeoutSeconds; default SDK timeout is ~70s and causes deadline-exceeded on large imports. */
const EXTRACT_BORROWERS_IMPORT_TIMEOUT_MS = 520_000;

const callableOptions = { timeout: EXTRACT_BORROWERS_IMPORT_TIMEOUT_MS };

function getExtractBorrowersImportCallable() {
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    const url = `${window.location.origin}/__fb_functions/extractBorrowersImport`;
    return httpsCallableFromURL(functions, url, callableOptions);
  }
  return httpsCallable(functions, 'extractBorrowersImport', callableOptions);
}

/**
 * @param {string} fileBase64
 * @param {string} fileName
 * @param {'fr'|'en'} locale
 * @returns {Promise<{ borrowers: Array<Record<string, unknown>> }>}
 */
export async function extractBorrowersImport(fileBase64, fileName, locale) {
  const extractBorrowersImportFn = getExtractBorrowersImportCallable();
  const res = await extractBorrowersImportFn({
    fileBase64,
    fileName,
    locale: locale === 'fr' ? 'fr' : 'en',
  });
  return res.data;
}
